module.exports = __webpack_public_path__ + "media/asset/images/Vector-2dbae651602ce01545bb6ec8bba6b901.svg";